import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import PropertyBar from "../../components/property/PropertyBar";
import PropertyCard from "../../components/property/PropertyCard";
import { useAppLatyoutContext } from "../../layouts/appLayout";
import useUser from "../../components/helpers/useUser";
import Pagination from "../../components/shared/Pagination";
import Loading from "../../components/shared/Loading";

const PropertyHomePage = () => {

    const [user, setUser] = useUser();

    const appLatyoutContext = useAppLatyoutContext();
    const [isLoading, setIsLoading] = useState(true);

    const {t,i18n} = useTranslation();
    const navigate = useNavigate();
    useDocumentTitle('المنشأت');
    const pageTitle = {title: 'المنشأت', subTitle: ''};
    const [properties, setProperties] = useState(null);
    const [unitsCount, setUnitsCount] = useState(null);
    const [propertiesCount, setPropertiesCount] = useState(null);

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);
    const [currentCount,setCurrentCount] = useState(0);
    const [hasMore,setHasMore] = useState(true);

    const [isEmpty, setIsEmpty] = useState(true);

    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
      if (querySearch.length > 0 && querySearch.length < 3) {
        return;
      }

      const delayDebounceFn = setTimeout(() => {
        getProperties(1, querySearch);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);

    const getProperties = async (page=1, searchTerm = "") => {
    
      let url = `/b-properties?business=${user?.business?._id ? user?.business._id : user?.business}&skip=${(page-1)*pageSize}&limit=${pageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }

      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setIsLoading(false);
          setProperties(response?.data?.properties);
          setPropertiesCount(response?.data?.numberOfAllProperties);
          setTotal(response?.data?.numberOfAllProperties);
          if(response?.data?.properties?.length > 0) {
            setCurrentCount(response?.data?.properties?.length);
            setCurrentPage(page);
            setIsEmpty(false);
          if(response?.data?.properties?.length === pageSize) {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
        } else {

        }
      } catch(err) {}
    }


    useEffect(()=>{
      if(user) {
        getProperties();
      }
    },[user]);

    useEffect(()=>{
      if(properties && Array.isArray(properties) && properties?.length > 0) {
        let unitsCount = 0;
        properties?.map(property=> unitsCount = unitsCount + parseInt(property?.numberOfUnits));
        setUnitsCount(unitsCount);
      }
    },[properties]);

    const handleClickPropertyCard = (id) => {
      navigate(`/ar/property/${id}`);
    }

    const handleChangePageAction = (page) => {
      getProperties(page);
    }
    
  return (
    <div>
      <PageHeader pageTitle={pageTitle} isColored/>
      <PageMain>
        <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
        <MainContent>
          <PropertyBar propertiesCount={propertiesCount || 0} />
          {properties !== null && Array.isArray(properties) && properties?.length < 1 && querySearch &&
            <div className="pt-[80px] text-center">
                <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لاتوجد منشأة مطابقة لكلمة البحث</div>
                {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/property/add">إنشاء منشأة جديدة</Link> */}
            </div> }
            {properties !== null && Array.isArray(properties) && properties?.length < 1 && !querySearch && !isEmpty && <Loading showLoading={true} />}
          {properties !== null && Array.isArray(properties) && properties?.length < 1 && !querySearch && isEmpty &&
            <div className="pt-[80px] text-center">
                <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-property-icon.svg')"}}></div>
                <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بإضافة أي منشأه حتى الآن</div>
                <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/property/add">إنشاء منشأة جديدة</Link>
            </div> }
            {properties !== null && Array.isArray(properties) && properties?.length > 0 && 
            <div className="pt-[25px] flex  gap-[32px] flex-wrap content-start min-h-[760px] pb-[83px] relative">
              {properties?.map(((property,index)=>{
                return <PropertyCard key={`property-${index}`} 
                                     image={property?.files?.length > 0 && property?.files[0]} 
                                     name={property?.name} 
                                     description={property?.description} 
                                     units={property?.numberOfUnits} 
                                     propertyType={property?.propertyType} 
                                     requests={property?.numberOfSubRequests || 0} 
                                     subProperties={property?.subProperties}
                                     commercialData={appLatyoutContext?.propertyTypes?.commercial}
                                     residentialData={appLatyoutContext?.propertyTypes?.residential}
                                     deleted={property?.deletedAt || false}
                                     onClick={()=>handleClickPropertyCard(property?._id)} />
              }))}
              <div className="w-full absolute bottom-0 left-0">
                <Pagination label={'منشآت'} total={total} currentCount={currentCount} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} hasMore={hasMore} />
              </div>
            </div> }
        </MainContent>
      </PageMain>

      <Loading showLoading={isLoading} />
    </div>
  );
};

export default PropertyHomePage;
